module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }